<template>
  <div class="">
    <!--About Four Start-->

    <section class="about-four">
      <div class="container">
        <!--Hero Section -->

        <div class="row" style="margin-top: -100px">
          <div class="col-xl-6">
            <div class="about-four__right">
              <div class="section-title text-left">
                <div class="section-title__icon">
                  <span class="fa fa-star"></span>
                </div>
                <!-- <span class="section-title__tagline">Welcome to govity</span> -->
                <h2 class="section-title__title">
                  FCT HEALTH <br />
                  INSURANCE <br />
                  SCHEME <br />
                  (FHIS)
                  <br />
                </h2>
              </div>
              <p class="about-four__text">
                FHIS’ vision; “A reputable health financing organization that
                ensures universal access to quality healthcare services for all
                residents of the Federal capital Territory.” Its mission commits
                the agency “To ensure all residents of the FCT have access to
                affordable, equitable and quality healthcare services through a
                well structured health financing system.” The scheme is built on
                solidarity, risk‑sharing and pooled pre‑payment, mirroring the
                National Health Insurance Authority (NHIA) model at federal
                level.
              </p>
              <!-- <ul class="about-four__points list-unstyled">
                <li>
                  <div class="icon">
                    <span class="fa fa-angle-right"></span>
                  </div>
                  <div class="content">
                    <h3>Council Information</h3>
                    <p>
                      It has survived not only five centuries. Lorem Ipsum is
                      simply dummy text of the new design printng.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="icon">
                    <span class="fa fa-angle-right"></span>
                  </div>
                  <div class="content">
                    <h3>Partner Organization</h3>
                    <p>
                      It has survived not only five centuries. Lorem Ipsum is
                      simply dummy text of the new design printng.
                    </p>
                  </div>
                </li>
              </ul> -->
            </div>
          </div>

          <div class="col-xl-6">
            <!--Reawards One Single Start-->

            <!--Reawards One Single End-->
            <div class="about-four__left">
              <div class="about-four__shape-1 img-bounce">
                <img src="assets/images/shapes/about-four-shape-1.png" alt="" />
              </div>
              <div class="about-four__img-box">
                <div class="about-four__img">
                  <img src="image/family-3.jpeg" class="img-rounded" />
                </div>
                <!-- <div class="about-four__img-2">
                  <img
                    src="assets/images/resources/about-four-img-2.jpg"
                    alt=""
                  />
                </div> -->
                <div class="about-four__content">
                  <h3>
                    FCT
                    <br />
                    Health <br />
                    Insurance Scheme <br />
                  </h3>
                  <!---<div class="about-four__icon">-->
                  <!---<span class="icon-cityscape"></span>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Hero Section -->

    <!--About One Start-->
    <section class="about-one">
      <div class="container">
        <div class="row">
          <div class="col-xl-6">
            <div class="about-one__left">
              <div class="about-one__shape-1 float-bob-x">
                <img src="assets/images/shapes/about-one-shape-1.png" alt="" />
              </div>
              <div class="about-one__shape-3 float-bob-y">
                <img src="assets/images/shapes/about-one-shape-3.png" alt="" />
              </div>
              <div class="about-one__img-box">
                <div class="about-one__img">
                  <img src="image/wike.jpeg" alt="" />
                </div>

                <!--<div class="about-one__img-2">
                                    <img src="assets/images/resources/about-one-img-2.jpg" alt="">
                                </div>
                <div class="about-one__shape-2">
                                    <img src="assets/images/shapes/about-one-shape-2.png" alt="">
                                </div>
                <!--<div class="about-one__video-link">
                                    <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" class="video-popup">
                                        <div class="about-one__video-icon">
                                            <span class="fa fa-play"></span>
                                            <i class="ripple"></i>
                                        </div>
                                    </a>
                                </div>-->
                <div class="about-one__call-box">
                  <div class="about-one__call-box-content">
                    <h4 class="about-one__call-number">
                      <a href="#">Rt. HON EZENWO NYESOM WIKE</a>
                    </h4>
                    <p class="about-one__call-text">FCT MINISTER</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          .
          <!--Minister of State-->
          <div class="col-xl-5">
            <div class="about-one__right" style="margin-top: 50px">
              <div class="about-one__shape-1 float-bob-x">
                <img src="assets/images/shapes/about-one-shape-1.png" alt="" />
              </div>
              <div class="about-one__shape-3 float-bob-y">
                <img src="assets/images/shapes/about-one-shape-3.png" alt="" />
              </div>
              <div class="about-one__img-box">
                <div class="about-one__img">
                  <img src="image/staff-2.jpg" alt="" />
                </div>
                <div class="about-one__call-box">
                  <div class="about-one__call-box-content">
                    <h4 class="about-one__call-number">
                      <a href="#"
                        >Dr. Mariya Mahmoud - (MBBS,MWACP,FMCFM,MPH)</a
                      >
                    </h4>
                    <p class="about-one__call-text">Minister of State FCT</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--End of Minister of State-->
          <div class="col-xl-6">
            <div class="about-one__right">
              <div class="section-title text-left">
                <div class="section-title__icon">
                  <span class="fa fa-star"></span>
                </div>
                <!-- <span class="section-title__tagline">Welcome to govity</span> -->
                <br />
                <br />
                <h2 class="section-title__title">Meet Our leaders</h2>
              </div>
              <p class="about-one__text">
                FHIS is committed to ensuring that all residents of the Federal
                Capital Territory, regardless of their socio-economic status,
                have universal access to quality essential healthcare services,
                reducing disparities in healthcare access.
              </p>
              <!-- <div class="about-one__icon-and-big-text">
                <div class="about-one__icon">
                  <span class="icon-cityscape"></span>
                </div>
                <p class="about-one__big-text">
                  Great city & place to develop your career & business.
                </p>
              </div> -->

              <div class="about-one__btn-box-and-signature">
                <a
                  href="https://app.claimify.ng/self-enrollment/930972/2648"
                  target="_blank"
                  class="about-one__btn thm-btn"
                  >Register Now</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--About One End-->

    <!--Feature One Start-->
    <section class="feature-one">
      <div class="container">
        <div class="row">
          <!--Feature One Single Start-->
          <div class="col-xl-4 col-lg-4">
            <div class="feature-one__single">
              <div class="feature-one__img-box">
                <div class="feature-one__img">
                  <img src="image/section-1.jpg" alt="" />
                </div>
                <div class="feature-one__content">
                  <div class="feature-one__icon">
                    <span class="icon-loan"></span>
                  </div>
                  <h3 class="feature-one__title">
                    <a href="#">Affordable Health<br /> </a>
                  </h3>
                </div>
                <div class="feature-one__content-two">
                  <div class="feature-one__content-two-top">
                    <div class="feature-one__icon-2">
                      <span class="icon-loan"></span>
                    </div>
                    <h3 class="feature-one__title-2">
                      <a href="#">Affordable Health <br /> </a>
                    </h3>
                  </div>
                  <div class="feature-one__content-two-bottom">
                    <p class="feature-one__content-two-text">
                      Stay healthy without the stress. FHIS offers affordable
                      healthcare that fits your budget. <br />
                    </p>
                    <div class="feature-one__content-two-btn-box">
                      <a href="#" class="feature-one__content-two-read-more"
                        >Read More<i
                          class="icon-right-arrow feature-one__content-two-arrow"
                        ></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Feature One Single End-->
          <!--Feature One Single Start-->
          <div class="col-xl-4 col-lg-4">
            <div class="feature-one__single">
              <div class="feature-one__img-box">
                <div class="feature-one__img">
                  <img src="image/section-2.jpg" alt="" />
                </div>
                <div class="feature-one__content">
                  <div class="feature-one__icon">
                    <span class="icon-cardiogram"></span>
                  </div>
                  <h3 class="feature-one__title">
                    <a href="#"
                      >Fast<br />
                      Delivery</a
                    >
                  </h3>
                </div>
                <div class="feature-one__content-two">
                  <div class="feature-one__content-two-top">
                    <div class="feature-one__icon-2">
                      <span class="icon-cardiogram"></span>
                    </div>
                    <h3 class="feature-one__title-2">
                      <a href="#"
                        >Fast <br />
                        Delivery</a
                      >
                    </h3>
                  </div>
                  <div class="feature-one__content-two-bottom">
                    <p class="feature-one__content-two-text">
                      Quick care when it counts. FHIS gives you fast access to
                      quality health services anytime, anywhere.
                    </p>
                    <div class="feature-one__content-two-btn-box">
                      <a href="#" class="feature-one__content-two-read-more"
                        >Read More<i
                          class="icon-right-arrow feature-one__content-two-arrow"
                        ></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Feature One Single End-->
          <!--Feature One Single Start-->
          <div class="col-xl-4 col-lg-4">
            <div class="feature-one__single">
              <div class="feature-one__img-box">
                <div class="feature-one__img">
                  <img src="image/section-5.jpg" alt="" />
                </div>
                <div class="feature-one__content">
                  <div class="feature-one__icon">
                    <span class="icon-corporate"></span>
                  </div>
                  <h3 class="feature-one__title">
                    <a href="#"
                      >High <br />
                      Quality</a
                    >
                  </h3>
                </div>
                <div class="feature-one__content-two">
                  <div class="feature-one__content-two-top">
                    <div class="feature-one__icon-2">
                      <span class="icon-corporate"></span>
                    </div>
                    <h3 class="feature-one__title-2">
                      <a href="#"
                        >High<br />
                        Quality</a
                      >
                    </h3>
                  </div>
                  <div class="feature-one__content-two-bottom">
                    <p class="feature-one__content-two-text">
                      Trusted healthcare, close to home. FHIS ensures fast,
                      quality care from skilled providers—so you stay healthy,
                      always.
                    </p>
                    <div class="feature-one__content-two-btn-box">
                      <a href="#" class="feature-one__content-two-read-more"
                        >Read More<i
                          class="icon-right-arrow feature-one__content-two-arrow"
                        ></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Feature One Single End-->
        </div>
      </div>
    </section>
    <!--Feature One End-->

    <!--Services One Start-->
    <!---
    <section class="services-one">
      <div class="container">
        <div class="row">
          <div class="col-xl-4">
            <div class="services-one__left">
              <div class="services-one__shape-2 img-bounce">
                <img
                  src="assets/images/shapes/services-one-shape-2.png"
                  alt=""
                />
              </div>
              <div class="services-one__img-box">
                <div class="services-one__img">
                  <img
                    src="assets/images/resources/services-one-img-1.png"
                    alt=""
                  />
                  <div class="services-one__img-shadow"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-8">
            <div class="services-one__right">
              <div class="services-one__shape-1 float-bob-x">
                <img
                  src="assets/images/shapes/services-one-shape-1.png"
                  alt=""
                />
              </div>
              <div class="services-one__shape-3 float-bob-x">
                <img
                  src="assets/images/shapes/services-one-shape-3.png"
                  alt=""
                />
              </div>
              <div class="services-one__points-title-box">
                <p>Explore online services & resource</p>
              </div>
              <div class="services-one__points-box">
                <ul class="services-one__points-list list-unstyled">
                  <li>
                    <a href="parking-permission.html"
                      >Parking Permission<span class="fa fa-angle-right"></span
                    ></a>
                  </li>
                  <li>
                    <a href="tax-return.html"
                      >File a Tax Return<span class="fa fa-angle-right"></span
                    ></a>
                  </li>
                  <li>
                    <a href="birth-certificate.html"
                      >Order Birth Certificate<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="building-permission.html"
                      >Get Building Permission<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="driving-license.html"
                      >Apply for Driving License<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="report-polution.html"
                      >Report Polution<span class="fa fa-angle-right"></span
                    ></a>
                  </li>
                </ul>
                <ul class="services-one__points-list list-unstyled">
                  <li>
                    <a href="report-polution.html"
                      >Public Service Identity<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="birth-certificate.html"
                      >Apply for a City Job<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="driving-license.html"
                      >Professional Licenses<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="building-permission.html"
                      >National Planning Framework<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="driving-license.html"
                      >Apply for Business License<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                  <li>
                    <a href="parking-permission.html"
                      >Online Court Services<span
                        class="fa fa-angle-right"
                      ></span
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->
    <!--Services One End-->

    <!--Video One Start-->
    <section class="video-one">
      <div
        class="video-one__bg jarallax"
        data-jarallax
        data-speed="0.2"
        data-imgPosition="50% 0%"
        style="background-image: url('image/fhis/activity-4.jpg')"
      ></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="video-one__inner">
              <!-- <div class="video-one__video-link">
                <a
                  href="https://www.youtube.com/watch?v=Get7rqXYrbQ"
                  class="video-popup"
                >
                  <div class="video-one__video-icon">
                    <span class="fa fa-play"></span>
                    <i class="ripple"></i>
                  </div>
                </a>
              </div> -->
              <h2 class="video-one__video-title">Our Journey So Far</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Video One End-->

    <!--Documents One Start-->
    <!---
    <section class="documents-one">
      <div class="container">
        <div class="documents-one__inner">
          <div class="documents-one__left">
            <p>
              Recent <br />
              documents
            </p>
          </div>
          <div class="documents-one__right">
            <ul class="documents-one__points list-unstyled">
              <li>
                <div class="documents-one__single">
                  <div class="documents-one__content">
                    <div class="documents-one__icon">
                      <span class="icon-download-circular-button"></span>
                    </div>
                    <h3 class="documents-one__title">
                      <a href="about.html">Vehicle Parking License</a>
                    </h3>
                    <p class="documents-one__text">
                      Download the license details file
                    </p>
                  </div>
                  <div class="documents-one__icon-two">
                    <span class="icon-pdf-file"></span>
                  </div>
                </div>
              </li>
              <li>
                <div class="documents-one__single">
                  <div class="documents-one__content">
                    <div class="documents-one__icon">
                      <span class="icon-download-circular-button"></span>
                    </div>
                    <h3 class="documents-one__title">
                      <a href="about.html">City Board Applications</a>
                    </h3>
                    <p class="documents-one__text">
                      Download the license details file
                    </p>
                  </div>
                  <div class="documents-one__icon-two">
                    <span class="icon-pdf-file"></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>-->
    <!--Documents One End-->

    <!--Counter One Start-->
    <section class="counter-one">
      <div
        class="counter-one__bg"
        style="background-image: url('image/fhis/activity-8.jpg')"
      ></div>
      <div class="container">
        <div class="counter-one__inner">
          <ul class="counter-one__list list-unstyled">
            <li>
              <div class="counter-one__count">
                <h3 ref="facilitiesCounter" class="odometer" :data-count="facilitiesCount">{{ facilitiesCount }}</h3>
                <span class=""></span>
              </div>
              <p class="counter-one__text">
                Health<br />
                Facilities
              </p>
            </li>
            <li>
              <div class="counter-one__count">
                <h3 ref="enrolleesCounter" class="odometer" :data-count="enrolleesCount">{{ enrolleesCount }}</h3>
                <span class=""></span>
              </div>
              <p class="counter-one__text">
                <br />
                Enrollees
              </p>
            </li>
            <li>
              <div class="counter-one__count">
                <h3 ref="tpasCounter" class="odometer" :data-count="tpasCount">{{ tpasCount }}</h3>
                <span class=""></span>
              </div>
              <p class="counter-one__text">TPAs <br /></p>
            </li>
            <!-- <li>
              <div class="counter-one__count">
                <h3 class="odometer" data-count="186">186</h3>
                <span class=""></span>
              </div>
              <p class="counter-one__text">
                Team <br />
                Members
              </p>
            </li> -->
          </ul>
        </div>
      </div>
    </section>
    <!--Counter One End-->

    <!--Team One Start-->
    <section class="team-one">
      <div class="container">
        <div class="section-title text-center">
          <div class="section-title__icon">
            <span class="fa fa-star"></span>
          </div>
          <span class="section-title__tagline">Key Management</span>
          <h2 class="section-title__title">Meet our Management Team <br /></h2>
        </div>
        <div class="team-one__inner">
          <div
            class="row justify-content-center text-center align-items-center"
          >
            <!--Team One Single Start-->
            <div class="col-xl-4 col-lg-4 d-flex">
              <div class="team-one__single">
                <div class="team-one__shape-2">
                  <img src="assets/images/shapes/team-one-shape-2.png" alt="" />
                </div>
                <div class="team-one__img-box">
                  <div class="team-one__img">
                    <img src="image/secretay.jpg" alt="" />
                  </div>
                </div>
                <div class="team-one__content">
                  <h3 class="team-one__name">
                    <a href="#">Dr. Adedolapo Fasawe</a>
                  </h3>
                  <p class="team-one__sub-title">
                    FCTA Secretary Health Services & Environment Secretariat
                    (HSES)
                  </p>
                  <div class="team-one__social">
                    <!-- <a href="#"><i class="fab fa-twitter"></i></a>
                    <a href="#"><i class="fab fa-facebook"></i></a>
                    <a href="#"><i class="fab fa-pinterest-p"></i></a>
                    <a href="#"><i class="fab fa-instagram"></i></a> -->
                  </div>
                </div>
              </div>
            </div>
            <!--Team One Single End-->
            <!--Team One Single Start-->
            <div class="col-xl-4 col-lg-4 d-flex" style="margin-top: 80px">
              <div class="team-one__single">
                <div class="team-one__shape-3">
                  <img src="assets/images/shapes/team-one-shape-3.png" alt="" />
                </div>
                <div class="team-one__img-box">
                  <div class="team-one__img">
                    <img src="image/perm-sec.jpg" alt="" />
                  </div>
                </div>
                <div class="team-one__content">
                  <h3 class="team-one__name">
                    <a href="#">Dr. Baba-Gana Adam</a>
                  </h3>
                  <p class="team-one__sub-title">
                    Permanent Secretary - Health Services and Environment
                    Secretariat
                  </p>
                  <div class="team-one__social">
                    <!-- <a href="#"><i class="fab fa-twitter"></i></a>
                    <a href="#"><i class="fab fa-facebook"></i></a>
                    <a href="#"><i class="fab fa-pinterest-p"></i></a>
                    <a href="#"><i class="fab fa-instagram"></i></a> -->
                  </div>
                </div>
              </div>
            </div>
            <!--Team One Single End-->
            <!--Team One Single Start-->
            <div
              class="col-xl-4 col-lg-4 d-flex justify-content-center"
              style="margin-top: 180px"
            >
              <div class="team-one__single">
                <div class="team-one__shape-3">
                  <img src="assets/images/shapes/team-one-shape-3.png" alt="" />
                </div>
                <div class="team-one__img-box">
                  <div class="team-one__img">
                    <img src="image/director-old.jpg" alt="" />
                  </div>
                </div>
                <div class="team-one__content">
                  <h3 class="team-one__name">
                    <a href="#">Dr. Salamatu Belgore</a>
                  </h3>
                  <p class="team-one__sub-title">Ag. Director of FHIS</p>
                  <div class="team-one__social">
                    <!-- <a href="#"><i class="fab fa-twitter"></i></a>
                    <a href="#"><i class="fab fa-facebook"></i></a>
                    <a href="#"><i class="fab fa-pinterest-p"></i></a>
                    <a href="#"><i class="fab fa-instagram"></i></a> -->
                  </div>
                </div>
              </div>
            </div>
            <!--Team One Single End-->
          </div>
        </div>
      </div>
    </section>
    <!--Team One End-->

    <!--Portfolio One Start-->
    <section class="portfolio-one">
      <div class="portfolio-one__top">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 col-lg-6">
              <div class="portfolio-one__left">
                <div class="section-title text-left">
                  <div class="section-title__icon">
                    <span class="fa fa-star"></span>
                  </div>
                  <!-- <span class="section-title__tagline">Recent work</span> -->
                  <h2 class="section-title__title">
                    Explore our Beautiful Gallery <br />
                  </h2>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6">
              <div class="portfolio-one__right">
                <div class="portfolio-one__text">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="portfolio-one__bottom">
        <div class="container">
          <div
            class="portfolio-one__carousel thm-owl__carousel owl-theme owl-carousel"
            data-owl-options='{
                        "items": 3,
                        "margin": 60,
                        "smartSpeed": 700,
                        "loop":true,
                        "autoplay": true,
                        "nav":false,
                        "dots":false,
                        "navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
                        "responsive":{
                            "0":{
                                "items":1
                            },
                            "768":{
                                "items":2
                            },
                            "992":{
                                "items": 3
                            },
                            "1200":{
                                "items":3
                            }
                        }
                    }'
          >
            <!--Portfolio One Single Start-->
            <div class="item">
              <div class="portfolio-one__single">
                <div class="portfolio-one__img-box">
                  <div class="portfolio-one__img">
                    <img src="image/fhis/activity-1.jpg" alt="" />
                  </div>
                  <div class="portfolio-one__content">
                    <p class="portfolio-one__sub-title"></p>
                    <h4 class="portfolio-one__title">
                      <a href="#">Community Engagements</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!--Portfolio One Single End-->
            <!--Portfolio One Single Start-->
            <div class="item">
              <div class="portfolio-one__single mar-top">
                <div class="portfolio-one__img-box">
                  <div class="portfolio-one__img">
                    <img src="image/fhis/activity-2.jpg" alt="" />
                  </div>
                  <div class="portfolio-one__content">
                    <p class="portfolio-one__sub-title">Road Walk for Health</p>
                    <h4 class="portfolio-one__title">
                      <a href="#">Road Walk for Health</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!--Portfolio One Single End-->
            <!--Portfolio One Single Start-->
            <div class="item">
              <div class="portfolio-one__single">
                <div class="portfolio-one__img-box">
                  <div class="portfolio-one__img">
                    <img src="image/fhis/activity-3.jpg" alt="" />
                  </div>
                  <div class="portfolio-one__content">
                    <p class="portfolio-one__sub-title">Enrollment for BHCPF</p>
                    <h4 class="portfolio-one__title">
                      <a href="#">Enrollment for BHCPF</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!--Portfolio One Single End-->
            <!--Portfolio One Single Start-->
            <div class="item">
              <div class="portfolio-one__single mar-top">
                <div class="portfolio-one__img-box">
                  <div class="portfolio-one__img">
                    <img src="image/fhis/activity-4.jpg" alt="" />
                  </div>
                  <div class="portfolio-one__content">
                    <p class="portfolio-one__sub-title">Walk for Health</p>
                    <h4 class="portfolio-one__title">
                      <a href="#">Walk for Health</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!--Portfolio One Single End-->
            <!--Portfolio One Single Start-->
            <div class="item">
              <div class="portfolio-one__single">
                <div class="portfolio-one__img-box">
                  <div class="portfolio-one__img">
                    <img src="image/fhis/activity-5.jpg" alt="" />
                  </div>
                  <div class="portfolio-one__content">
                    <p class="portfolio-one__sub-title">Seminar</p>
                    <h4 class="portfolio-one__title">
                      <a href="#">Seminar</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!--Portfolio One Single End-->
          </div>
        </div>
      </div>
    </section>
    <!--Portfolio One End-->

    <!--Brand One Start-->
    <section class="brand-one">
      <div class="container">
        <div class="brand-one__title">
          <p>Our partners & supporters</p>
        </div>
        <div
          class="brand-one__carousel thm-owl__carousel owl-theme owl-carousel"
          data-owl-options='{
                    "items": 3,
                    "margin": 0,
                    "smartSpeed": 700,
                    "loop":true,
                    "autoplay": 6000,
                    "nav":false,
                    "dots":false,
                    "navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
                    "responsive":{
                        "0":{
                            "items":1
                        },
                        "768":{
                            "items":3
                        },
                        "992":{
                            "items": 5
                        }
                    }
                }'
        >
          <!--Brand One Single-->
          <div class="brand-one__single">
            <div class="brand-one__img">
              <img src="image/unitedhealthcare.jpg" alt="" />
            </div>
          </div>
          <!--Brand One Single-->
          <div class="brand-one__single">
            <div class="brand-one__img">
              <img src="image/venushmo.jpg" alt="" />
            </div>
          </div>
          <!--Brand One Single-->
          <div class="brand-one__single">
            <div class="brand-one__img">
              <img src="image/songhai.jpg" alt="" />
            </div>
          </div>
          <!--Brand One Single-->
          <div class="brand-one__single">
            <div class="brand-one__img">
              <img src="image/prohealth.jpeg" alt="" />
            </div>
          </div>
          <!--Brand One Single-->
          <div class="brand-one__single">
            <div class="brand-one__img">
              <img src="image/ashemdhmo.png" alt="" />
            </div>
          </div>
        </div>
        <!-- If we need navigation buttons -->
      </div>
    </section>
    <!--Brand One End-->

    <!--Event One Start-->
    <section class="event-one">
      <div class="event-one__shape-1">
        <img src="assets/images/shapes/event-one-shape-1.jpg" alt="" />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xl-8">
            <div class="event-one__left">
              <div class="section-title text-left">
                <div class="section-title__icon">
                  <span class="fa fa-star"></span>
                </div>
                <span class="section-title__tagline">Latest events</span>
                <h2 class="section-title__title">
                  Activities & <br />
                  events
                </h2>
              </div>
              <ul class="event-one__points list-unstyled">
                <li>
                  <div class="event-one__single">
                    <div class="event-one__img-box">
                      <div class="event-one__img">
                        <img src="image/fhis/activity-3.jpg" alt="" />
                      </div>
                      <div class="event-one__date">
                        <p>
                          30 <br />
                          MAY
                        </p>
                      </div>
                    </div>
                    <div class="event-one__content">
                      <div class="event-one__tag">
                        <p>Flag-off</p>
                      </div>
                      <ul class="event-one__meta list-unstyled">
                        <li>
                          <div class="icon">
                            <span class="fas fa-clock"></span>
                          </div>
                          <div class="text">
                            <p>08:00am - 05:00pm</p>
                          </div>
                        </li>
                        <li>
                          <div class="icon">
                            <span class="fas fa-map-marker"></span>
                          </div>
                          <div class="text">
                            <p>Garki 11, Abuja FCT</p>
                          </div>
                        </li>
                      </ul>
                      <h3 class="event-one__title">
                        <a href="#">Flag-off Enrollment for BHCPF</a>
                      </h3>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="event-one__single">
                    <div class="event-one__img-box">
                      <div class="event-one__img">
                        <img src="image/fhis/activity-2.jpg" alt="" />
                      </div>
                      <div class="event-one__date">
                        <p>
                          30 <br />
                          MAY
                        </p>
                      </div>
                    </div>
                    <div class="event-one__content">
                      <div class="event-one__tag">
                        <p>Celebration</p>
                      </div>
                      <ul class="event-one__meta list-unstyled">
                        <li>
                          <div class="icon">
                            <span class="fas fa-clock"></span>
                          </div>
                          <div class="text">
                            <p>08:00am - 05:00pm</p>
                          </div>
                        </li>
                        <li>
                          <div class="icon">
                            <span class="fas fa-map-marker"></span>
                          </div>
                          <div class="text">
                            <p>Garki 11, Abuja FCT</p>
                          </div>
                        </li>
                      </ul>
                      <h3 class="event-one__title">
                        <a href="#">Walk for Health</a>
                      </h3>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4">
            <div class="event-one__right">
              <div class="event-one__subscribe-top">
                <div
                  class="event-one__subscribe-top-bg"
                  style="background-image: url('image/fhis/activity-6.jpg')"
                ></div>
                <div class="event-one__subscribe-icon">
                  <span class="icon-newsletter"></span>
                </div>
                <p class="event-one__subscribe-text">
                  Subscribe to <br />
                  our newslette for <br />
                  daily updates
                </p>
                <p class="event-one__subscribe-text-2">
                  Get latest news & events details
                </p>
              </div>
              <div class="event-one__subscribe-bottom">
                <div
                  class="event-one__subscribe-bottom-bg"
                  style="
                    background-image: url(assets/images/backgrounds/event-one-subscribe-bottom-bg.png);
                  "
                ></div>
                <form class="event-one__email-box">
                  <div class="event-one__email-input-box">
                    <input
                      type="email"
                      placeholder="Email Address"
                      name="email"
                    />
                  </div>
                  <button
                    type="submit"
                    class="event-one__subscribe-btn thm-btn"
                  >
                    Subscribe
                  </button>
                </form>
                <p class="event-one__subscribe-text-3">
                  Never share your email with others.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Event One End-->
    <!--Tesimonial Three Start-->
    <section class="testimonial-three">
      <div
        class="testimonial-three__bg"
        style="
          background-image: url(assets/images/backgrounds/testimonial-three-bg.png);
        "
      ></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-4">
            <div class="testimonial-three__left">
              <div class="section-title text-left">
                <div class="section-title__icon">
                  <span class="fa fa-star"></span>
                </div>
                <span class="section-title__tagline">Our testimonials</span>
                <h2 class="section-title__title">
                  Hear from our Enrollees <br />
                </h2>
              </div>
              <p class="testimonial-three-left__text"></p>
            </div>
          </div>
          <div class="col-xl-8">
            <div class="testimonial-three__right">
              <div
                class="testimonial-three__carousel thm-owl__carousel owl-theme owl-carousel"
                data-owl-options='{
                                "items": 3,
                                "margin": 30,
                                "smartSpeed": 700,
                                "loop":true,
                                "autoplay": false,
                                "nav":false,
                                "dots":false,
                                "navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
                                "responsive":{
                                    "0":{
                                        "items":1
                                    },
                                    "768":{
                                        "items":2
                                    },
                                    "992":{
                                        "items": 2
                                    },
                                    "1200":{
                                        "items": 1.333333
                                    }
                                }
                            }'
              >
                <!--Testimonial One Single Start-->
                <div class="item">
                  <div class="testimonial-three__single">
                    <div class="testimonial-three__single-inner">
                      <div class="testimonial-three__shape-1">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-1.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__shape-2">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-2.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__quote">
                        <span class="icon-quote"></span>
                      </div>
                      <p class="testimonial-three__text">
                        Since joining FHIS, I no longer worry about hospital
                        bills. My children and I get treated quickly and for
                        free.
                      </p>
                      <div class="testimonial-three__client-info">
                        <div class="testimonial-three__client-img-box">
                          <div class="testimonial-three__client-img">
                            <img
                              src="assets/images/testimonial/testimonial-3-1.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="testimonial-three__client-content">
                          <div class="testimonial-three__client-rating">
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                          </div>
                          <h3 class="testimonial-three__client-name">
                            Aisha U. Garki
                          </h3>
                          <p class="testimonial-three__client-sub-title">...</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Testimonial One Single End-->
                <!--Testimonial One Single Start-->
                <div class="item">
                  <div class="testimonial-three__single">
                    <div class="testimonial-three__single-inner">
                      <div class="testimonial-three__shape-1">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-1.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__shape-2">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-2.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__quote">
                        <span class="icon-quote"></span>
                      </div>
                      <p class="testimonial-three__text">
                        As a trader, I couldn't afford private insurance. FHIS
                        gives me peace of mind at a low cost.
                      </p>
                      <div class="testimonial-three__client-info">
                        <div class="testimonial-three__client-img-box">
                          <div class="testimonial-three__client-img">
                            <img
                              src="assets/images/testimonial/testimonial-3-2.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="testimonial-three__client-content">
                          <div class="testimonial-three__client-rating">
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                          </div>
                          <h3 class="testimonial-three__client-name">
                            Ibrahim S., Kuje
                          </h3>
                          <p class="testimonial-three__client-sub-title">
                            CEO - CO Founder
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Testimonial One Single End-->
                <!--Testimonial One Single Start-->
                <div class="item">
                  <div class="testimonial-three__single">
                    <div class="testimonial-three__single-inner">
                      <div class="testimonial-three__shape-1">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-1.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__shape-2">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-2.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__quote">
                        <span class="icon-quote"></span>
                      </div>
                      <p class="testimonial-three__text">
                        I used to avoid going to the hospital because of cost.
                        With FHIS, I now go whenever I need care.
                      </p>
                      <div class="testimonial-three__client-info">
                        <div class="testimonial-three__client-img-box">
                          <div class="testimonial-three__client-img">
                            <img
                              src="assets/images/testimonial/testimonial-3-3.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="testimonial-three__client-content">
                          <div class="testimonial-three__client-rating">
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                          </div>
                          <h3 class="testimonial-three__client-name">
                            Aleesha martin
                          </h3>
                          <p class="testimonial-three__client-sub-title">
                            CEO - CO Founder
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Testimonial One Single End-->
                <!--Testimonial One Single Start-->
                <div class="item">
                  <div class="testimonial-three__single">
                    <div class="testimonial-three__single-inner">
                      <div class="testimonial-three__shape-1">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-1.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__shape-2">
                        <img
                          src="assets/images/shapes/testimonial-three-shape-2.png"
                          alt=""
                        />
                      </div>
                      <div class="testimonial-three__quote">
                        <span class="icon-quote"></span>
                      </div>
                      <p class="testimonial-three__text">
                        My elderly parents are covered by FHIS and it has really
                        helped our family manage health expenses
                      </p>
                      <div class="testimonial-three__client-info">
                        <div class="testimonial-three__client-img-box">
                          <div class="testimonial-three__client-img">
                            <img
                              src="assets/images/testimonial/testimonial-3-4.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="testimonial-three__client-content">
                          <div class="testimonial-three__client-rating">
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                            <span class="fa fa-star"></span>
                          </div>
                          <h3 class="testimonial-three__client-name">
                            Chinedu
                          </h3>
                          <p class="testimonial-three__client-sub-title">...</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Testimonial One Single End-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Tesimonial Three End-->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  components: {
    HelloWorld,
  },
  data() {
    return {
      facilitiesCount: 368, // Default value
      enrolleesCount: 180010, // Default value
      tpasCount: 14, // Default value
    };
  },
  async mounted() {
    await this.fetchCounterData();
    // Wait a bit for DOM to be fully ready
    setTimeout(() => {
      this.initializeOdometer();
    }, 500);
  },
  methods: {
    async fetchCounterData() {
      try {
        const response = await fetch('https://claimify-api.hayokmedicare.ng/api/v1/enrollee-data/930972');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        
        // Update counter values from API response
        if (data.facilities !== undefined) {
          this.facilitiesCount = data.facilities;
        }
        if (data.total !== undefined) {
          this.enrolleesCount = data.total;
        }
        if (data.tpas !== undefined) {
          this.tpasCount = data.tpas;
        }
        
        console.log('Counter data updated:', data);
      } catch (error) {
        console.error('Error fetching counter data:', error);
        // Keep default values on error
      }
    },
    initializeOdometer() {
      // Re-initialize odometer after data update
      this.$nextTick(() => {
        if (window.Odometer) {
          // Force odometer to update with new values
          const counters = [
            { ref: this.$refs.facilitiesCounter, value: this.facilitiesCount },
            { ref: this.$refs.enrolleesCounter, value: this.enrolleesCount },
            { ref: this.$refs.tpasCounter, value: this.tpasCount }
          ];
          
          counters.forEach(({ ref, value }) => {
            if (ref && value !== undefined) {
              // Clear existing odometer instance
              ref.innerHTML = value;
              
              // Create new odometer instance
              const odometer = new window.Odometer({
                el: ref,
                value: 0,
                format: '(,ddd)'
              });
              
              // Animate to the target value
              setTimeout(() => {
                odometer.update(value);
              }, 100);
            }
          });
        }
      });
    }
  }
};
</script>
